
import React, { createContext, useState, useContext, useEffect } from 'react';
import { auth } from './fbase'; // fbase.js에서 auth 객체를 가져옵니다.

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // 로딩 상태 추가

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
      if (firebaseUser) {
        const userRole = await fetchUserRole(firebaseUser.uid);
        setUser({
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          role: userRole,
        });
      } else {
        setUser(null);
      }
      setLoading(false); // 인증 상태 확인이 끝나면 로딩 종료
    });

    return () => unsubscribe();
  }, []);

  // 실제 애플리케이션에서는 이 함수를 API 호출로 구현해야 합니다.
  const fetchUserRole = async (uid) => {
    try {
      // package.json에 설정된 proxy를 통해 API를 호출합니다.
      const response = await fetch("/json/getUserRole.php", { 
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ uid: uid }), // uid를 서버로 전송
      });

      if (!response.ok) {
        throw new Error('서버에서 역할을 가져오는데 실패했습니다.');
      }

      const data = await response.json();
      // 서버 응답 형식에 따라 role 값을 추출하여 반환합니다. 예: { "role": "admin" }
      return data.role || 'user'; // 역할 데이터가 없으면 기본값 'user'를 반환합니다.

    } catch (error) {
      console.error("Failed to fetch user role:", error);
      return 'user'; // 에러 발생 시에도 기본 역할을 반환합니다.
    }
  };


  return (
    <UserContext.Provider value={{ user, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
